import React from 'react';

export default function BackupModal({ onClose, user, partnerships }) {
  const isAdmin = user && user.role === 'admin';
  const token = localStorage.getItem('token');

  const download = async (url, filename) => {
    try {
      const res = await fetch(url, { headers: { 'Authorization': 'Token ' + token } });
      const blob = await res.blob();
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = filename + '_' + new Date().toISOString().slice(0,10) + '.zip';
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
    } catch(e) { alert('خطأ: ' + e.message); }
  };

  return (
    <div style={{position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.5)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center',direction:'rtl'}}>
      <div style={{background:'white',borderRadius:'12px',padding:'25px',width:'550px',maxWidth:'95vw',boxShadow:'0 20px 60px rgba(0,0,0,0.3)'}}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'20px'}}>
          <h3 style={{margin:0,color:'#1e3a5f'}}>💾 النسخة الاحتياطية</h3>
          <button onClick={onClose} style={{background:'none',border:'none',fontSize:'20px',cursor:'pointer',color:'#666'}}>✕</button>
        </div>
        {isAdmin && (
          <div style={{background:'#e8f4fd',padding:'15px',borderRadius:'8px',marginBottom:'15px',border:'1px solid #bee3f8'}}>
            <p style={{margin:'0 0 12px',fontWeight:'bold',color:'#1e3a5f',fontSize:'14px'}}>🔑 نسخة الأدمن - جميع الشراكات</p>
            <div style={{display:'flex',gap:'10px',flexWrap:'wrap'}}>
              <button onClick={()=>download('/api/backup/', 'wells_full_backup')}
                style={{padding:'10px 16px',background:'#1e3a5f',color:'white',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'13px',fontWeight:'bold'}}>
                💾 نسخة كاملة (كود + بيانات)
              </button>
              <button onClick={()=>download('/api/backup-db/', 'wells_db_backup')}
                style={{padding:'10px 16px',background:'#27ae60',color:'white',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'13px',fontWeight:'bold'}}>
                🗄️ نسخة البيانات فقط (SQL)
              </button>
            </div>
          </div>
        )}
        <div style={{background:'#f0f4f8',padding:'15px',borderRadius:'8px',marginBottom:'15px',border:'1px solid #dce3ea'}}>
          <p style={{margin:'0 0 12px',fontWeight:'bold',color:'#1e3a5f',fontSize:'14px'}}>📦 نسخة شراكة محددة</p>
          <div style={{display:'flex',gap:'10px',flexWrap:'wrap'}}>
            {(isAdmin ? partnerships : (partnerships||[]).filter(p=>Number(p.id)===Number(user&&user.partnership_id)))?.map(p=>(
              <button key={p.id} onClick={()=>download('/api/backup-partnership/'+p.id+'/', 'backup_'+p.id)}
                style={{padding:'10px 16px',background:'#8e44ad',color:'white',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'12px',fontWeight:'bold'}}>
                📦 {p.name}
              </button>
            ))}
          </div>
        </div>
        <button onClick={onClose} style={{padding:'9px 20px',background:'#95a5a6',color:'white',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'13px'}}>إغلاق</button>
      </div>
    </div>
  );
}
